import { useMemo, useRef } from "react";
function usePrevious(value) {
  const ref = useRef({
    value,
    previous: value
  });
  return useMemo(() => (ref.current.value !== value && (ref.current.previous = ref.current.value, ref.current.value = value), ref.current.previous), [value]);
}
export { usePrevious };